import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { checkIfCollaborator, isValidEmail } from '@guryou/utils';
// import './print.css';

const FileReportTable = forwardRef(({ printData }, ref) => {
  const { t } = useTranslation();
  const checkIfCollaboratorIsLoggedIn = checkIfCollaborator();
  return (
    <div style={{ width: '100%', height: '70vh', margin: '0', padding: '0' }}>
      <table className="report-container" ref={ref}>
        <thead className="report-header">
          <tr>
            <th className="report-header-cell">
              <div className="header-info">{t('GENERAL.clientName')}</div>
            </th>
            <th className="report-header-cell">
              <div className="header-info">{t('GENERAL.email')}</div>
            </th>
            <th className="report-header-cell">
              <div className="header-info">{t('SECTION_VIDEOS.sectionName')}</div>
            </th>
            <th className="report-header-cell">
              <div className="header-info">{t('SECTION_VIDEOS.watched')}</div>
            </th>
            <th className="report-header-cell">
              <div className="header-info">{t('SECTION_VIDEOS.total')}</div>
            </th>
            <th className="report-header-cell">
              <div className="header-info">{t('SECTION_VIDEOS.percentage')}</div>
            </th>
          </tr>
        </thead>
        <tbody className="report-content">
          {printData?.map(x => (
            <tr key={`${x.id}`} className="report-content-row">
              <td className="report-content-cell">
                <div className="main">{x?.name}</div>
              </td>
              <td className="report-content-cell">
                <div className="main">{checkIfCollaboratorIsLoggedIn ? null : isValidEmail(x?.email) ? x?.email : null}</div>
              </td>

              <td className="report-content-cell">
                <div className="main">{x?.sectionName}</div>
              </td>

              <td className="report-content-cell">
                <div className="main">{x?.watched}</div>
              </td>
              <td className="report-content-cell">
                <div className="main">{x?.total}</div>
              </td>
              <td className="report-content-cell">
                <div className="main">{x?.percentage}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default FileReportTable;
